export default "__VITE_ASSET__e0f33017__"